@if (isFirst) {
  <td>
    @if (isFirst) {
      <material-order-position-status [id]="position.position_id"
        [status]="position.status"
        (updatePosition)="updatePositionEmitter.emit($event)"
        >
      </material-order-position-status>
    }
  </td>
  <td class="align-right">{{position.index}}</td>
  <td class="align-right">
    @if (position.delivery_index === 0) {
      <span>1</span>
    }
    @if (position.delivery_index > 0) {
      <strong>{{position.delivery_index + 1}}</strong>
    }
  </td>
  @if (groupPermission) {
    <td>
      <a uiSref="a.material.inventory.update" target="_blank" [uiParams]="{variation: position.id}">
        {{position.variation_id}}
      </a>
    </td>
  }
  @if (!groupPermission) {
    <td>
      {{position.variation_id}}
    </td>
  }
  <td>{{position.vendor_article_id}}</td>
  <td>{{position.article_name}}</td>
  @for (field of fields; track field) {
    <td [ngClass]="{'align-right': field.isValueType('Number')}">
      @if (!(position.fields[field.html_name]|isNull)) {
        @switch (field.data_type) {
          @case ('Option') {
        <i class="fa" [ngClass]="{
          'fa-check':(position.fields[field.html_name] === true),
          'fa-times': (position.fields[field.html_name] === false)}"></i>
          }
          @case ('Ganzzahl') {
            {{ position.fields[field.html_name] | money:0 }}
          }
          @case ('Kommazahl') {
            {{ position.fields[field.html_name] | money }}
          }
          @default {
            {{ position.fields[field.html_name] }}
          }
        }
      }
    </td>
  }
  <td>
    {{position.date_delivery|date:'dd.MM.yyyy'}}
    @if (position.date_delivery_first_contact &&
      (position.date_delivery !== position.date_delivery_first_contact)) {
      <span style="font-size: 8px">
        <br />{{position.date_delivery_first_contact | date:'dd.MM.yyyy'}}
      </span>
    }
  </td>
  <td class="align-right">
    {{position.amount_ordered|money}}
    @if (position.amount_ordered_first_contact &&
      (position.amount_ordered !== position.amount_ordered_first_contact)) {
      <span style="font-size: 8px">
        <br />{{position.amount_ordered_first_contact|money}}
      </span>
    }
  </td>
}

@if (!isFirst) {
  <td [colSpan]="8 + fields.length"></td>
}

<ng-container [formGroup]="form">
  @if (('material.order.price.check'|HasPerm)) {
    <td class="align-right">
      @if (!!position.price) {
        {{position.price|money:2}}&nbsp;&euro;
      }
    </td>
  }
  <td>
    <input type="text" class="form-control" formControlName="charge">
  </td>
  <td>
    <input type="text" class="form-control" formControlName="location" [ngClass]="{red_alert: errorLocation}">
  </td>
  <td>
    <input type="number"
      class="form-control align-right"
      min="0"
      formControlName="amount"
      [ngClass]="{red_alert: errorAmount}">
    @if (errorAmount) {
      <span class="red_font">Keine negativen Werte</span>
    }
  </td>
</ng-container>

@if (isFirst) {
  <td class="align-right">{{remaining|money}}</td>
  <td class="icon"></td>
  <td class="icon">
    <a class="click" title="Einbuchungsposition hinzufügen" (click)="addTransactionForm()">
      <i class="fa fa-plus-circle green row-icon" aria-hidden="true"></i>
    </a>
  </td>
  <td>
    @if (('material.order.status'|HasPerm)) {
      <a class="click" title="Position als &quot;Gebucht&quot; markieren" (click)="setStatus(2)">
        <i class="fa fa-check gray_font row-icon" aria-hidden="true"></i>
      </a>
    }
  </td>
  <td>
    <material-label-print-button [variationId]="position.id" classInner="fa-2x"></material-label-print-button>
  </td>
}

@if (!isFirst) {
  <td></td>
  <td class="icon"></td>
  <td class="icon">
    <a class="click" (click)="removeTransactionForm()">
      <i class="fa fa-minus-circle red_font row-icon" title="Einbuchungsposition entfernen"></i>
    </a>
  </td>
  <td colspan="2"></td>
}
